export default __webpack_public_path__ + "static/media/vip.68e03958.svg";